import { WEEKDAYS } from 'constants/dates';
import { Subtitle } from 'themes/organic/components';
import { ContentContainer } from 'themes/organic/components/ContentContainer';

import { useBusiness } from 'hooks/business/useBusiness';

import { getFormattedBusinessHours } from 'utils/getFormattedBusinessHours';

import s from './OrganicBusinessHoursSection.module.css';

export const OrganicBusinessHoursSection = () => {
  const { address, addressLink, businessHours, showAddress } = useBusiness();

  return (
    <section className={s.root}>
      <ContentContainer className={s.content}>
        <Subtitle className={s.header}>Hours and Location</Subtitle>
        {showAddress && (
          <a
            href={addressLink}
            className={s.address}
            target="_blank"
            rel="noreferrer"
          >
            {address}
          </a>
        )}
        <table className={s.table}>
          <tbody>
            {WEEKDAYS.map((name) => {
              const { start, end, working } = businessHours[name.toLowerCase()];

              if (working) {
                return (
                  <tr key={name}>
                    <td>{name}</td>
                    <td>
                      {getFormattedBusinessHours(start)} -{' '}
                      {getFormattedBusinessHours(end)}
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={name}>
                  <td>{name}</td>
                  <td>Closed</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </ContentContainer>
    </section>
  );
};
